import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selected", "menu", "search", "option", "placeholder", "checkbox", "indicator"]
  static values  = { preselected: { type: Array, default: [] } }

  preselectedValueChanged() {
    if (this.preselectedValue.length === 0) return
    const preselected = this.preselectedValue.map(String)
    this.optionTargets.forEach((option, i) => {
      if (preselected.includes(String(option.dataset.value))) {
        this.checkboxTargets[i].checked = true
        this.indicatorTargets[i].classList.add("bg-primary", "border-primary-strong")
        this.indicatorTargets[i].querySelector("svg").classList.remove("hidden")
      }
    })
    this.updateTags()
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener("click", this.closeOnClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  toggle(event) {
    if (event.target.closest(".selected-tag")) return
    this.menuTarget.classList.toggle("hidden")
    if (!this.menuTarget.classList.contains("hidden")) {
      this.searchTarget.focus()
    }
  }

  search() {
    const query = this.searchTarget.value.toLowerCase()
    this.optionTargets.forEach(option => {
      const searchText = option.dataset.search || ""
      option.style.display = searchText.includes(query) ? "" : "none"
    })
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    const checkbox = option.querySelector("input[type='checkbox']")
    const indicator = option.querySelector(".checkbox-indicator")
    const svg = indicator.querySelector("svg")

    checkbox.checked = !checkbox.checked

    if (checkbox.checked) {
      indicator.classList.add("bg-primary", "border-primary-strong")
      svg.classList.remove("hidden")
    } else {
      indicator.classList.remove("bg-primary", "border-primary-strong")
      svg.classList.add("hidden")
    }

    this.updateTags()
  }

  removeTag(event) {
    event.stopPropagation()
    const value = event.currentTarget.dataset.value
    const option = this.optionTargets.find(opt => opt.dataset.value === value)

    if (option) {
      const checkbox = option.querySelector("input[type='checkbox']")
      const indicator = option.querySelector(".checkbox-indicator")
      const svg = indicator.querySelector("svg")

      checkbox.checked = false
      indicator.classList.remove("bg-primary", "border-primary-strong")
      svg.classList.add("hidden")
    }

    this.updateTags()
  }

  updateTags() {
    // Remove existing tags
    this.selectedTarget.querySelectorAll(".selected-tag").forEach(tag => tag.remove())

    const checkedOptions = this.optionTargets.filter(opt =>
      opt.querySelector("input[type='checkbox']").checked
    )

    if (checkedOptions.length === 0) {
      this.placeholderTarget.classList.remove("hidden")
    } else {
      this.placeholderTarget.classList.add("hidden")

      checkedOptions.forEach(option => {
        const name = option.dataset.name
        const value = option.dataset.value

        const tag = document.createElement("span")
        tag.className = "selected-tag inline-flex items-center gap-1 bg-primary-subtle text-primary-strong text-sm px-2 py-1 rounded"
        tag.innerHTML = `
          ${name}
          <button type="button" class="hover:text-primary-strong-hover" data-action="click->multi-select#removeTag" data-value="${value}">
            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
            </svg>
          </button>
        `

        this.selectedTarget.appendChild(tag)
      })
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
